import { Heading, HeadingProps, Text, TextProps } from '@chakra-ui/react'
import { FC } from 'react'

export const SuperTitle: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h1"
      fontWeight={800}
      fontSize={{ base: '4.25rem', lg: '6.5rem' }}
      sx={{
        fontFeatureSettings: "'ss01' on"
      }}
      letterSpacing={{ base: '-0.04em', lg: '-0.03em' }}
      lineHeight={{ base: '4.5rem', lg: '7rem' }}
      {...props}
    />
  )
}

export const H1: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h1"
      fontWeight={800}
      fontSize={{ base: '2rem', lg: '3.25rem' }}
      sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
      letterSpacing="-0.04em"
      lineHeight={{ base: '2.5rem', lg: '3.75rem' }}
      {...props}
    />
  )
}

export const H2: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h2"
      fontWeight={800}
      fontSize={{ base: '1.75rem', lg: '2.75rem' }}
      sx={{
        fontFeatureSettings: {
          base: "'ss01' on, 'liga' off, 'calt' off",
          lg: "'ss01' on"
        }
      }}
      letterSpacing={{ base: '-0.02em', lg: '-0.03em' }}
      lineHeight={{ base: '2rem', lg: '3.25rem' }}
      {...props}
    />
  )
}

export const H3: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h3"
      fontWeight={800}
      fontSize={{ base: '1.5rem', lg: '2.5rem' }}
      sx={{ fontFeatureSettings: "'ss01' on, 'calt' off, 'liga' off" }}
      letterSpacing={{ base: '-0.02em', lg: '-0.03em' }}
      lineHeight={{ base: '1.75rem', lg: '3rem' }}
      {...props}
    />
  )
}

export const H4: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h4"
      fontWeight={800}
      fontSize={{ base: '1.25rem', lg: '2.25rem' }}
      sx={{ fontFeatureSettings: "'ss07' on, 'ss01' on, 'calt' off, 'liga' off" }}
      letterSpacing={{ base: '-0.02em', lg: '-0.03em' }}
      lineHeight={{ base: '1.5rem', lg: '2.5rem' }}
      {...props}
    />
  )
}

export const H5: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h5"
      fontWeight={800}
      fontSize={{ base: '1rem', lg: '1.5rem' }}
      sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off" }}
      letterSpacing={{ base: '-0.01em', lg: '-0.03em' }}
      lineHeight={{ base: '1.25rem', lg: '1.75rem' }}
      {...props}
    />
  )
}

export const H6: FC<HeadingProps> = (props) => {
  return (
    <Heading
      color="inherit"
      as="h6"
      fontWeight={800}
      fontSize={{ base: '15px', lg: '20px' }}
      sx={{ fontFeatureSettings: "'ss01' on, 'liga' off, 'calt' off", textEdge: 'cap', leadingTrim: 'both' }}
      letterSpacing={{ base: '-0.6px', lg: '-0.15px' }}
      lineHeight={{ base: '20px', lg: '24px' }}
      {...props}
    />
  )
}

export const Body1: FC<TextProps> = (props) => {
  return (
    <Text
      color="inherit"
      fontWeight={{ base: 700, lg: 600 }}
      fontSize={{ base: '1rem', lg: '17px' }}
      lineHeight={{ base: '1.25rem', lg: '24px' }}
      letterSpacing="-0.02em"
      {...props}
    />
  )
}

export const Body1Strong: FC<TextProps> = (props) => {
  return <Body1 fontWeight={700} {...props} />
}

export const Body2: FC<TextProps> = (props) => {
  return (
    <Text
      color="inherit"
      fontWeight={600}
      fontSize={{ base: '14px', lg: '15px' }}
      lineHeight={{ base: '18px', lg: '20px' }}
      letterSpacing="-0.01em"
      {...props}
    />
  )
}

export const Body2Strong: FC<TextProps> = (props) => {
  return <Body2 fontWeight={700} {...props} />
}

export const Body3: FC<TextProps> = (props) => {
  return (
    <Text
      color="inherit"
      fontWeight={{ base: 500, lg: 600 }}
      fontSize={{ base: '12px', lg: '13px' }}
      lineHeight={{ base: '16px', lg: '18px' }}
      letterSpacing={{ base: 'normal', lg: '-0.02em' }}
      {...props}
    />
  )
}

export const Label: FC<TextProps> = (props) => {
  return (
    <Text
      color="inherit"
      fontWeight={{ base: 600, lg: 700 }}
      fontSize={{ base: '14px', lg: '15px' }}
      sx={{ fontFeatureSettings: "'ss01' on, 'calt' off, 'liga' off" }}
      letterSpacing="-0.01em"
      lineHeight={{ base: '18px', lg: '20px' }}
      {...props}
    />
  )
}

export const Subtitle: FC<TextProps> = (props) => {
  return <Text fontWeight={600} fontSize="1.2rem" lineHeight="6" display="inline" {...props} />
}
